// alterado - revisado

import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    SvgIconDiaDia,
    SvgIconEducacao,
    SvgIconFinanciamento,
    SvgIconDiaDiaDespesasTemporarias,
    SvgIconProjetoVidaSonho,
} from '../../../business-components/SvgIcon/SvgIconDespesasTotais/SvgIconDespesasTotais'

import {
    SvgIconTotal,
} from '../../../business-components/SvgIcon/SvgIconEstudo/SvgIconEstudo'

import EstudoFormPanel from './EstudoFormPanel'

import EstudoFormDespesasDiaDiaDespesasVitalicias from '../estudo-form/EstudoFormDespesasDiaDiaDespesasVitalicias'

import EstudoFormDespesasEducacao from '../estudo-form/EstudoFormDespesasEducacao'

import EstudoFormDespesasFinanciamento from '../estudo-form/EstudoFormDespesasFinanciamento'

import EstudoFormDespesasDiaDiaDespesasTemporarias from '../estudo-form/EstudoFormDespesasDiaDiaDespesasTemporarias'

import EstudoFormProjetoVidaSonho from '../estudo-form/EstudoFormProjetoVidaSonho'

import EstudoFormGroupPanel from './EstudoFormGroupPanel'



const EstudoFormDespesasPanelRadioGroup = ({ values, estudo }) => {

    const panelList = 
        [
            {
                id: 1,
                descricao: estudo.current.panelDespesasTotais[HARDCODE.indexEstudoDiaDia].descricao,
                svgIcon: SvgIconDiaDia,
                conteudo:
                    <EstudoFormPanel
                        values={values}
                        panelValores={estudo.current.panelDespesasTotais[HARDCODE.indexEstudoDiaDia]}
                        tipoPanel={HARDCODE.tipoPanelDespesasTotais}
                    />,
                form: 
                    <EstudoFormDespesasDiaDiaDespesasVitalicias
                        values={values}
                        estudo={estudo}
                    />,
            },
            {
                id: 2,
                descricao: estudo.current.panelDespesasTotais[HARDCODE.indexEstudoEducacao].descricao,
                svgIcon: SvgIconEducacao,
                conteudo:
                    <EstudoFormPanel
                        values={values}
                        panelValores={estudo.current.panelDespesasTotais[HARDCODE.indexEstudoEducacao]}
                        tipoPanel={HARDCODE.tipoPanelDespesasTotais}
                    />,
                form: 
                    <EstudoFormDespesasEducacao
                        values={values}
                        estudo={estudo}
                    />,
            },
            {
                id: 3,
                descricao: estudo.current.panelDespesasTotais[HARDCODE.indexEstudoFinanciamento].descricao,
                svgIcon: SvgIconFinanciamento,
                conteudo:
                    <EstudoFormPanel
                        values={values}
                        panelValores={estudo.current.panelDespesasTotais[HARDCODE.indexEstudoFinanciamento]}
                        tipoPanel={HARDCODE.tipoPanelDespesasTotais}
                    />,
                form: 
                    <EstudoFormDespesasFinanciamento
                        values={values}
                        estudo={estudo}
                    />,
            },
            {
                id: 4,
                descricao: estudo.current.panelDespesasTotais[HARDCODE.indexEstudoDiaDiaDespesasTemporarias].descricao,
                svgIcon: SvgIconDiaDiaDespesasTemporarias,
                conteudo:
                    <EstudoFormPanel
                        values={values}
                        panelValores={estudo.current.panelDespesasTotais[HARDCODE.indexEstudoDiaDiaDespesasTemporarias]}
                        tipoPanel={HARDCODE.tipoPanelDespesasTotais}
                    />,
                form: 
                    <EstudoFormDespesasDiaDiaDespesasTemporarias
                        values={values}
                        estudo={estudo}
                    />,
            },
            {
                id: 5,
                descricao: estudo.current.panelDespesasTotais[HARDCODE.indexEstudoProjetoVidaSonho].descricao,
                svgIcon: SvgIconProjetoVidaSonho,
                conteudo:
                    <EstudoFormPanel
                        values={values}
                        panelValores={estudo.current.panelDespesasTotais[HARDCODE.indexEstudoProjetoVidaSonho]}
                        tipoPanel={HARDCODE.tipoPanelDespesasTotais}
                    />,
                form: 
                    <EstudoFormProjetoVidaSonho
                        values={values}
                        estudo={estudo}
                    />,
            },
            {
                id: 6,
                descricao: estudo.current.panelDespesasTotais[HARDCODE.indexEstudoTotalDespesas].descricao,
                svgIcon: SvgIconTotal,
                conteudo:
                    <EstudoFormPanel
                        values={values}
                        panelValores={estudo.current.panelDespesasTotais[HARDCODE.indexEstudoTotalDespesas]}
                        tipoPanel={HARDCODE.tipoPanelDespesasTotais}
                    />,
                form:
                    <>
                        <EstudoFormDespesasDiaDiaDespesasVitalicias
                            values={values}
                            estudo={estudo}
                        />
                        <EstudoFormDespesasEducacao
                            values={values}
                            estudo={estudo}
                        />
                        <EstudoFormDespesasFinanciamento
                            values={values}
                            estudo={estudo}
                        />
                        <EstudoFormDespesasDiaDiaDespesasTemporarias
                            values={values}
                            estudo={estudo}
                        />
                        <EstudoFormProjetoVidaSonho
                            values={values}
                            estudo={estudo}
                        />
                    </>,
                total: true,
            },
        ]

    return (
        <EstudoFormGroupPanel
            title={LABEL.despesasTotais}
            panelList={panelList}
        />
    )
}

export default EstudoFormDespesasPanelRadioGroup